export default "__VITE_ASSET__CsAwXiKS__"